import { useMemo } from 'react';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { PROPERTIES } from '../constants';
import { FormType } from '../types';
import UnavailableNonHubSpotData from '../UnavailableNonHubSpotData';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function ViewsCell({
  crmObject,
  propertyName
}) {
  const propertyValue = getPropertyValue(crmObject, propertyName);
  const viewText = useMemo(() => propertyValue || '0', [propertyValue]);
  const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
  if (formType === FormType.CAPTURED) return /*#__PURE__*/_jsx(UnavailableNonHubSpotData, {});
  return /*#__PURE__*/_jsx(_Fragment, {
    children: viewText
  });
}
export const views = {
  width: 150,
  multiline: true,
  renderCell: props => /*#__PURE__*/_jsx(ViewsCell, Object.assign({}, props))
};